import { apiClient } from 'services/api-client';

export const postComplianceProgram  = async (data) => {
  return await apiClient.post(`/compliance-program`, data);
};

export const getComplianceProgramDetails = async (id) => {
  return await apiClient.get(`/compliance-program?companyKey=${id}`)
}

export const getComplianceProgramDashboard = async (id) => {
  return await apiClient.get(`/compliance-program/dashboard?companyKey=${id}`)
}

export const getComplianceProgramCheck = async (id) => {
  return await apiClient.get(`/compliance-program/check?companyKey=${id}`)
}

export const getComplianceProgramProgress = async (id) => {
  return await apiClient.get(`/compliance-program/progress?companyKey=${id}`)
}